import { render, staticRenderFns } from "./LottoMessages.vue?vue&type=template&id=faf01b64&scoped=true&"
import script from "./LottoMessages.vue?vue&type=script&lang=js&"
export * from "./LottoMessages.vue?vue&type=script&lang=js&"
import style0 from "./LottoMessages.vue?vue&type=style&index=0&id=faf01b64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf01b64",
  null
  
)

export default component.exports